<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 px-0 px-sm-4 pt-4>
        <v-layout wrap justify-center>
          <v-flex xs10 sm12 xl12 text-left text-uppercase>
            <span
              style="
                font-family: ibmsemibold;
                font-size: 16px;
                color: #000000;
                letter-spacing: 1px;
              "
            >
              Profile Details
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start pt-4>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmregular;
                    font-size: 14px;
                    color: #8E8E8E;
                  "
                >
                  Full Name
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmmedium;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ appUser.firstname }}&nbsp;{{ appUser.lastname }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmregular;
                    font-size: 14px;
                    color: #8E8E8E;
                  "
                >
                  Mobile Number
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmmedium;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  +91 {{ appUser.phone }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmregular;
                    font-size: 14px;
                    color: #8E8E8E;
                  "
                >
                  Email ID
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmmedium;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ appUser.email }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmregular;
                    font-size: 14px;
                    color: #8E8E8E;
                  "
                >
                  Gender
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                v-if="appUser.gender"
                  style="
                    font-family: ibmmedium;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ appUser.gender }}
                </span>
                <span v-else>-</span>

              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: ibmregular;
                    font-size: 14px;
                    color: #8E8E8E;
                  "
                >
                  Date of birth
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                v-if="appUser.dob"
                  style="
                    font-family: ibmmedium;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ formatDate(appUser.dob) }}
                </span>
                <span v-else>-</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
              
                  style="
                    font-family: ibmregular;
                    font-size: 14px;
                    color: #8E8E8E;
                  "
                >
                  Location
                </span>

              </v-flex>
              <v-flex xs12 text-left>
                <span
                  v-if="appUser.locationname"
                  style="
                    font-family: ibmmedium;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ appUser.locationname }}
                </span>
                <span v-else>-</span>

              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
  },
  data() {
    return {
      profile: [
        { label: "Full Name", value: this.appUser },
        { label: "Mobile Number", value: "+91 8547 541 254" },
        { label: "Email ID", value: "boydphilips@gmail.com" },
        { label: "Gender", value: "Male" },
        { label: "Date of birth", value: "14 Jan 1992" },
        { label: "Location", value: "Cochin" },
      ],
    };
  },
  methods:{
    
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
  }
};
</script>